module.exports = __webpack_public_path__ + "img/alberta-2297204_1920.1a47e734.jpg";